import styled from "styled-components";

interface Props {
  backgroundColor?: string;
  height?: string;
  width?: string;
}

const CircularLoader = styled.div<Props>`
  position: relative;
  width: ${({ width }) => width || "30px"};
  height: ${({ height }) => height || "30px"};
  border-radius: 10rem;
  border: 2px solid white;
  border-color: ${({ backgroundColor }) => backgroundColor || "white"};
  background: linear-gradient(#b54ad1 0%, #b54ad1 20%, #f8edfb 100%);

  animation: animate 1s linear infinite;

  &::before {
    position: absolute;
    content: "";
    background: ${({ backgroundColor }) => backgroundColor || "white"};
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 60%;
    height: 60%;
    border-radius: 10rem;
    border: 3px solid white;
    border-color: ${({ backgroundColor }) => backgroundColor || "white"};
  }

  @keyframes animate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

export default CircularLoader;
